import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { employeeApi } from "../../app/slices/employeeSlice";
import { Box, LinearProgress } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI
import NameSearchComponent from "../../components/customTable/NameSearchComponent";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { useMediaQuery, useTheme } from "@mui/material";

export default function Employee() {
  const dispatch = useDispatch();

  const sliceResponse = useSelector((state) => state.employee.employee.data);
  const stateLoading = useSelector(
    (state) => state.employee.loading
  );
  
  // loading={stateLoading}
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("Email", {
      header: "Email",
      size: 30,
    }),
    columnHelper.accessor("PhoneNo", {
      header: "Phone Number",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.PhoneNo}</div>
      ),
    }),
    columnHelper.accessor("Designation", {
      header: "Designation",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.Designation}
        </div>
      ),
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,

      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partner_id}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("username", {
      header: "Username",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.username}</div>
      ),
    }),

    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.partner_username}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  useEffect(() => {
    if (searchTerm) {
      // If searchTerm is provided, search by name
      dispatch(employeeApi({ name: searchTerm }));
    } else if (queryParams.startDate && queryParams.endDate) {
      // If startDate and endDate are provided, search by date range
      dispatch(employeeApi(queryParams));
    } else {
      // Default API call without filters
      dispatch(employeeApi({}));
    }
  }, [dispatch, searchTerm, queryParams]);

  const handleSearchByDate = (startDate, endDate) => {
    setSearchTerm(""); // Clear name search when using date search
    setQueryParams({ startDate, endDate });
  };

  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check
  
  return (
    <>
     {/*  */}
       <Box>
              <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                alignItems={isMobile ? "stretch" : "center"}
                justifyContent={isMobile ? "flex-start" : "space-between"}
                mb={2}
              >
                <Box width={isMobile ? "100%" : "40%"}>
                  <NameSearchComponent
                    onSearch={(name) => {
                      setQueryParams({ startDate: null, endDate: null });
                      setSearchTerm(name);
                    }}
                  />
                </Box>
                <Box
                  width={isMobile ? "100%" : "55%"}
                  mt={isMobile ? 2 : 0}
                  ml={isMobile ? 0 : 0}
                >
                  <DateSearchComponent onSearch={handleSearchByDate} />
                </Box>
              </Box>
              <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="Employees"/>
            </Box>
      
      
        {/* <>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <NameSearchComponent
              onSearch={(name) => {
                setQueryParams({ startDate: null, endDate: null }); 
                setSearchTerm(name);
              }}
            />

            <DateSearchComponent onSearch={handleSearchByDate} />
          </Box>
          <CustomTable columns={columns} data={sliceResponse} loading={stateLoading}/>
        </> */}
      
    </>
  );
}
